import { BundlePrice } from 'components/BundlePrice';
import { SpecialOfferProps } from '../types';
import { StyledDecaSpecialOffer } from './styles';
import { EBundlesInternalViewModel, EProductPriority } from 'utils/enums';
import { useEffect, useMemo, useState } from 'react';
import { ProductData } from 'utils/types';
import { SubProduct } from './SubProducts';
import { AutoTextSize } from 'utils/autoTextSizeUtils/auto-text-size-react';
import { MainProduct } from 'templates/Bundles/Deca/MainProduct';
import DecaTooltip from 'components/DecaTooltip';
import decaTooltipIcon from 'assets/Deca/deca-tooltip.png';

export const DecaSpecialOffer: React.FC<SpecialOfferProps> = ({
  prices,
  productsList,
  selectOffer,
  isFree,
  collectText,
  availabilityText = 'Availability',
  availability,
  timer,
  subTitle,
  backgroundImage,
  backgroundColor = { colorOne: '#880000' },
  inMobileMock,
  offerDisplayName = '',
  offerDescription = '',
}) => {
  const [mainProduct, setMainProduct] = useState<ProductData | null>(null);
  const [subProducts, setSubProducts] = useState<ProductData[]>([]);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  useEffect(() => {
    if (!productsList || productsList.length === 0) return;

    setMainProduct(
      productsList.find(
        (product) => product.priority === EProductPriority.MAIN,
      ) ?? null,
    );

    setSubProducts(
      productsList.filter(
        (product) => product.priority === EProductPriority.SUB,
      ) ?? [],
    );
  }, [productsList]);

  const availabilityDisplayText = useMemo(
    () =>
      availability
        ? `${availabilityText} ${availability.remaining}/${availability.total}`
        : '',
    [availability],
  );

  return (
    <StyledDecaSpecialOffer onClick={selectOffer}>
      {isTooltipOpen && !inMobileMock && (
        <DecaTooltip
          prices={prices}
          setIsTooltipOpen={setIsTooltipOpen}
          product={mainProduct?.images?.product}
          traits={mainProduct?.traits}
          backgroundSrc={backgroundImage}
          backgroundColor={backgroundColor}
          subProducts={subProducts}
          isTooltipOpen={isTooltipOpen}
          offerName={offerDisplayName}
          productName={
            mainProduct?.displayName
              ? mainProduct?.displayName
              : mainProduct?.name
          }
          tooltipDescription={offerDescription}
          isFree={isFree}
          buttonText={collectText}
          classDescription={mainProduct?.description || ''}
        />
      )}
      <div className="container">
        <img
          onClick={(e) => {
            e.stopPropagation();
            setIsTooltipOpen(true);
          }}
          className="tooltip"
          src={decaTooltipIcon}
          alt="deca-tooltip"
        />
        <div className="content">
          <div className="mainProductContainer">
            <div className="title">{offerDisplayName}</div>
            <div className="subtitle">{subTitle && <>{subTitle}</>}</div>
            <MainProduct
              product={mainProduct?.images?.product}
              traits={mainProduct?.traits}
              backgroundSrc={backgroundImage}
              backgroundColor={backgroundColor}
            />
            <div className="bottomContent">
              {timer && (
                <div className="timer">
                  <AutoTextSize
                    mode="oneline"
                    maxFontSizePx={8}
                    minFontSizePx={4}
                    as="div"
                  >
                    Ends in {timer}
                  </AutoTextSize>
                </div>
              )}
              {availabilityDisplayText && (
                <div className="availability">
                  <AutoTextSize
                    mode="oneline"
                    maxFontSizePx={8}
                    minFontSizePx={4}
                    as="div"
                  >
                    {availabilityDisplayText}
                  </AutoTextSize>
                </div>
              )}
            </div>
          </div>
          <div className="subProductsContainer">
            <div className="subProductsContainer__scroll">
              {subProducts.map(
                ({ textFontColorHex, quantityDisplay, images }, index) => (
                  <SubProduct
                    key={index}
                    product={images?.product}
                    quantityDisplay={quantityDisplay}
                    textFontColorHex={textFontColorHex}
                  />
                ),
              )}
            </div>
          </div>
        </div>
      </div>
      <BundlePrice
        prices={prices}
        type={EBundlesInternalViewModel.DECA}
        isFree={isFree}
        buttonText={collectText}
      />
    </StyledDecaSpecialOffer>
  );
};
